import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface UserState {
  id: number;
  email: string;
  token: string;
  user_id?: number;
  password?: string;
  agent_id?: number;
  user_name?: string;
  stateData?: any;
  // Add other optional properties
}

const initialState: UserState = {
  id: 0,
  email: '', // Initialize email
  token: '', // Initialize token
  stateData: {},
  // Initialize other properties if needed
};
const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<UserState>) {
      state.id = action.payload.id;
      // Update other properties if needed
    },
    setStateData(state, action: PayloadAction<any>) {
      Object.assign(state.stateData, action.payload);
      sessionStorage.setItem('stateData', JSON.stringify(action.payload));
    },
    getStateData(state) {
      return state.stateData || JSON.parse(sessionStorage.getItem('stateData') || '{}');
    },
    clearUser(state) {
      state.id = 0;
      // Clear other properties if needed
    },
  },
});

export const { setUser, clearUser, setStateData, getStateData } = userSlice.actions;
export default userSlice.reducer;
